import { Component } from '@angular/core';

@Component({
  selector: 'app-thums-up-svg',
  standalone: true,
  template: `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1130_10547"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1130_10547)">
        <path
          d="M14.776 16.5833H5.67658V7.41663L11.3722 1.7533L11.7022 1.87496C11.9276 2.03094 12.1002 2.22538 12.2199 2.4583C12.3395 2.69121 12.3715 2.93323 12.316 3.18434L12.2951 3.2083L11.5355 7.41663H17.2439C17.6125 7.41663 17.9279 7.54781 18.1901 7.81017C18.4525 8.07239 18.5837 8.38781 18.5837 8.75642V9.6233C18.5837 9.72371 18.5759 9.81371 18.5603 9.8933C18.5449 9.97288 18.5164 10.056 18.4747 10.1427L16.1062 15.7189C15.9875 15.9832 15.8086 16.1934 15.5693 16.3493C15.33 16.5053 15.0655 16.5833 14.776 16.5833ZM6.75991 15.5H14.776C14.8347 15.5 14.8948 15.4839 14.9562 15.4518C15.0177 15.4198 15.0645 15.3664 15.0966 15.2916L17.5003 9.68746V8.75642C17.5003 8.68156 17.4763 8.6201 17.4282 8.57205C17.3802 8.52399 17.3187 8.49996 17.2439 8.49996H10.2472L11.1878 3.45351L6.75991 7.86538V15.5ZM5.67658 7.41663V8.49996H2.50033V15.5H5.67658V16.5833H1.41699V7.41663H5.67658Z"
          fill="#EA5B0C"
        />
      </g>
    </svg>
  `,
})
export class ThumsUpSvgComponent {}
